namespace advisorop.components.servicer {

    // AI Connections: the OAuth clients AI assistants (Claude, ChatGPT, ...) use to connect to
    // AdvisorOp over MCP. Servicer admins only - the API enforces it; the guard here is cosmetic.
    class AiConnectionsController {

        $router;
        user: domains.identity.IUser;
        isAuthorized: boolean;

        serverInfo: domains.IMcpServerInfo;
        clients: Array<domains.IMcpClient> = [];
        loading: boolean = false;

        // the new-connection form
        newProvider: domains.McpClientProvider = domains.McpClientProvider.CLAUDE;
        newName: string = "";
        newRedirectUris: string = "";
        saving: boolean = false;

        // the credentials just issued; shown until dismissed, never again
        issued: domains.IMcpClientSecret;

        // the connection being edited
        editing: { id: number, name: string, provider: domains.McpClientProvider, redirectUris: string };

        readonly customProvider = domains.McpClientProvider.CUSTOM;

        static $inject = ["identityService", "mcpClientService"];
        constructor(private identityService: services.IdentityService,
            private mcpClientService: services.McpClientService) {
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.isAuthorized = (this.user && this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());

                if (!this.isAuthorized) {
                    try {
                        this.$router.parent.navigate(["Dashboard"]);
                    } catch (e) {
                        // content is hidden by ng-if anyway
                    }
                    return;
                }

                this.mcpClientService.getServerInfo()
                    .then(r => { this.serverInfo = r.data; })
                    .catch(err => toastr.error("Failed to load the server details" + this.reason(err)));

                this.load();
            });
        }

        load(): void {
            this.loading = true;
            this.mcpClientService.list()
                .then(r => { this.clients = r.data; })
                .catch(err => toastr.error("Failed to load AI connections" + this.reason(err)))
                .finally(() => { this.loading = false; });
        }

        selectedPreset(): domains.IMcpClientPreset {
            if (!this.serverInfo)
                return null;
            return this.serverInfo.presets.filter(p => p.provider == this.newProvider)[0] || null;
        }

        create(): void {
            var redirectUris = this.newProvider == this.customProvider ? this.lines(this.newRedirectUris) : [];
            if (this.newProvider == this.customProvider && redirectUris.length == 0) {
                toastr.warning("Enter at least one callback URL.");
                return;
            }

            this.saving = true;
            this.mcpClientService.create(this.newProvider, this.newName, redirectUris)
                .then(r => {
                    this.issued = r.data;
                    this.newName = "";
                    this.newRedirectUris = "";
                    toastr.success("Connection created. Copy the client secret now.");
                    this.load();
                })
                .catch(err => toastr.error("Could not create the connection" + this.reason(err)))
                .finally(() => { this.saving = false; });
        }

        regenerateSecret(client: domains.IMcpClient): void {
            if (!window.confirm(`Create a new secret for "${client.name}"?\n\nThe current secret stops working immediately. `
                + `The assistant keeps working only until you enter the new secret there.`))
                return;

            this.mcpClientService.regenerateSecret(client.id)
                .then(r => {
                    this.issued = r.data;
                    toastr.success("New secret created. Copy it now.");
                    this.load();
                })
                .catch(err => toastr.error("Could not create a new secret" + this.reason(err)));
        }

        revoke(client: domains.IMcpClient): void {
            if (!window.confirm(`Revoke "${client.name}"?\n\nEveryone connected through it is disconnected immediately. `
                + `This cannot be undone; you would create a new connection instead.`))
                return;

            this.mcpClientService.revoke(client.id)
                .then(() => {
                    toastr.success("Connection revoked.");
                    if (this.issued && this.issued.client.id == client.id)
                        this.issued = null;
                    this.load();
                })
                .catch(err => toastr.error("Could not revoke the connection" + this.reason(err)));
        }

        startEdit(client: domains.IMcpClient): void {
            this.editing = {
                id: client.id,
                name: client.name,
                provider: client.provider,
                redirectUris: (client.redirectUris || []).join("\n")
            };
        }

        saveEdit(): void {
            var e = this.editing;
            this.mcpClientService.update(e.id, e.name, this.lines(e.redirectUris))
                .then(() => {
                    toastr.success("Connection updated.");
                    this.editing = null;
                    this.load();
                })
                .catch(err => toastr.error("Could not update the connection" + this.reason(err)));
        }

        copy(text: string, what: string): void {
            (navigator as any).clipboard.writeText(text)
                .then(() => toastr.success(`${what} copied.`))
                .catch(() => toastr.warning(`Could not copy. Select the ${what.toLowerCase()} and copy it by hand.`));
        }

        private lines(text: string): string[] {
            return (text || "").split(/\r?\n/).map(s => s.trim()).filter(s => s.length > 0);
        }

        private reason(err): string {
            return err && typeof err.data === "string" && err.data ? `: ${err.data}` : "";
        }

        $routerOnActivate(next, previous) {
        }
    }

    class AiConnections implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AiConnectionsController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/ai-connections.html';
        }
    }
    angular.module(Constants.APP).component("aiConnections", new AiConnections());
}
